import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const skillmanagementapi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'skillmanagementapi',
    endpoints: (builder) => ({

        addSkills: builder.mutation({
            query: (data) => ({
                url: '/student/skills/add',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllSkillCategory: builder.query({
            query: () => ({
                url: `/student/skill-category/dropdown`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getListSkillCategory: builder.query({
            query: () => ({
                url: `/student/skills/dropdown`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteSkill: builder.mutation({
            query: (skillId) => ({
                url: `/student/skills/remove?skillId=${skillId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    }),
});

export const {
    useAddSkillsMutation, useLazyGetAllSkillCategoryQuery,
    useDeleteSkillMutation, useLazyGetListSkillCategoryQuery,
} = skillmanagementapi;

export default skillmanagementapi;
